import { MergeSiteDescription } from './MergeSiteDescription.js'
export default MergeSiteDescription




// WEBPACK FOOTER //
// ./src/components/MergeSiteDescription/index.js